// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"193":"unauthorized","238":"forbidden","472":"settings"}[chunkId] + "." + {"193":"da781f2f","238":"b418b8c2","472":"5fad3157"}[chunkId] + ".js";
};